import { RevolvaService, ProductInfo, ProductList, PiecesInfo } from './revolva.service';
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { RoughnessMipmapper } from "three/examples/jsm/utils/RoughnessMipmapper.js";
import * as THREE from "three";
import * as actionsCustom from "@/service/revolva.action-custom";
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { StereoEffect } from 'three/examples/jsm/effects/StereoEffect.js';



export function renderOrSterio(service: RevolvaService) {
    if (service.isSterioEffect) {
        service.stereoEffect.render(service.scene, service.camera);

    }
    else {
        service.renderer.render(service.scene, service.camera);
    }
}

export function loadGround(service: RevolvaService) {
    const { scene } = service
    const loader = new THREE.TextureLoader();
    const groundTexture = loader.load('../../textures/ground.jpg');
    groundTexture.wrapS = groundTexture.wrapT = THREE.RepeatWrapping;
    groundTexture.repeat.set(1, 1);
    groundTexture.anisotropy = 16;
    groundTexture.encoding = THREE.sRGBEncoding;

    const groundMaterial = new THREE.MeshLambertMaterial({ map: groundTexture });

    const mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(1.5, 1.5), groundMaterial);
    mesh.position.y = - 0.2;
    mesh.rotation.x = - Math.PI / 2;
    //mesh.receiveShadow = true;
    scene.add(mesh);
}


export function renderModel(service: RevolvaService) {
    const { renderer, scene, camera, animation, controls, controlerAutoRotat, mixer, clock, sliderValue } = service
    // console.log("renderMode");
    if (animation) {
        //console.log("animation");
        setTimeout(function () {
            requestAnimationFrame(() => renderModel(service));

            actionsCustom.watchAnimation(service)
            if (mixer) mixer.update(clock.getDelta());
            // stats.update();
        }, 1000 / 9);

        // setTimeout(function () {
        //     service.animation = false;
        // }, 30000);



        // console.log(mixer)
    }
    if (controlerAutoRotat) {
        controls.update();
    }

    renderOrSterio(service);
}


export function onWindowResize(service: RevolvaService) {
    const { camera, renderer, canvaFullScreen, canvaHeight, canvasWidth } = service
    let tempCavasH = canvaHeight;
    let tempCavasW = canvasWidth;
    if (canvaFullScreen
    ) {
        tempCavasH =
            document.getElementById("model-container").offsetHeight;
        tempCavasW =
            document.getElementById("model-container").offsetWidth;
    }

    camera.aspect = tempCavasW / tempCavasH;
    camera.updateProjectionMatrix();
    renderer.setSize(tempCavasW, tempCavasH);

    renderModel(service);
}





export function onPointerDown(service: RevolvaService, event: any) {
    event.preventDefault();
    service.mouse.x = (event.clientX / service.renderer.domElement.clientWidth) * 2 - 1;
    service.mouse.y = - (event.clientY / service.renderer.domElement.clientHeight) * 2 + 1;
    service.raycaster.setFromCamera(service.mouse, service.camera);
    //const index = actionsCustom.getIndex(service,'piece1' , 'Circle005');
    //console.log(index);
    const intersects = service.raycaster.intersectObjects(service.piecesInScene['piece1'].children);
    if (intersects.length > 0) {
        const object = intersects[0].object;
        //console.log(object);
        if (object.name === 'Circle014') {
            object.position.y = object.position.y + 0.2;
            renderModel(service);

            setTimeout(() => {
                // stats.update();
                object.position.y = object.position.y - 0.2;
                renderModel(service);
                actionsCustom.playSound(service);

            }, 300);


            actionsCustom.updateAnnotationText(service, "SOUND", "This is generic text, generated by 3Digital.");

        }
        if (object.name === 'Cube006') {
            actionsCustom.updateAnnotationText(service, "BRACELET", "This is generic text, generated by 3Digital..");

        }
        if (object.name === 'Circle009') {
            actionsCustom.updateAnnotationText(service, "DIAL", "This is generic text, generated by 3Digital..");

        }
    }
    renderModel(service);
}

export function onTouch(service: RevolvaService, event: any) {
    event.preventDefault();
    service.mouse.x = (event.changedTouches[0].clientX / service.renderer.domElement.clientWidth) * 2 - 1;
    service.mouse.y = - (event.changedTouches[0].clientY / service.renderer.domElement.clientHeight) * 2 + 1;
    service.raycaster.setFromCamera(service.mouse, service.camera);
    //const index = actionsCustom.getIndex(service,'piece1' , 'Circle005');
    //console.log(index);
    const intersects = service.raycaster.intersectObjects(service.piecesInScene['piece1'].children);
    if (intersects.length > 0) {
        const object = intersects[0].object;
        //console.log(object);
        if (object.name === 'Circle014') {
            object.position.y = object.position.y + 0.2;
            renderModel(service);

            setTimeout(() => {
                // stats.update();
                object.position.y = object.position.y - 0.2;
                renderModel(service);
                actionsCustom.playSound(service);

            }, 300);

            actionsCustom.updateAnnotationText(service, "SONIC POWER", "Thanks to the patented gongs, case construction and silent striking regulator, the Supersonnerie provides exceptional acoustic performance, sound quality, and harmonic tone.");


            // if(service.showInfo){
            //     document.querySelector(".annotation")
            // }
        }
        if (object.name === 'Cube006') {
            actionsCustom.updateAnnotationText(service, "Bracelt", "Hand-stitched “large square scale” blue alligator strap with 18-carat white gold folding clasp.");

        }
        if (object.name === 'Circle009') {
            actionsCustom.updateAnnotationText(service, "Dial", "Smoked blue enamel dial, 18-carat white gold applied hour-markers and hands, enamel transferred logo, lacquered black inner bezel.");

        }

    }
    renderModel(service);
}




export function init(service: RevolvaService) {
    const { scene, canvas, camera, renderer, controls, light, ground, controlerAutoRotat, controlerRotatOnlyOnX } = service;

    camera.position.set(0, 0, 0.5);

    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.domElement.style.outline = "none";
    renderer.shadowMap.enabled = true;
    //renderer.shadowMap.type = THREE.PCFShadowMap; 
    // renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMappingExposure = 0.3;

    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();
    //scene.add(new THREE.AmbientLight(0x666666));

    light.position.set(0, 3, 3);
    light.castShadow = false;
    light.shadow.bias = -0.00001;
    light.shadow.mapSize.width = 1024 * 2;
    light.shadow.mapSize.height = 1024 * 2;
    light.shadow.radius = 2;

    /* const d = 300;

    light.shadow.camera.left = - d;
    light.shadow.camera.right = d;
    light.shadow.camera.top = d;
    light.shadow.camera.bottom = - d; */

    //light.shadow.camera.far = 3;

    //const hemiLight = new THREE.HemisphereLight(0xffeeb1, 0x080820, 4);
    //scene.add(hemiLight);

    //const color = 0xFFFFFF;
    //const intensity = 1;
    //const lightA = new THREE.AmbientLight(color, intensity);
    //scene.add(lightA);




    //scene.add(light);

    const newLight = new THREE.DirectionalLight(0xffffff, 1);
    newLight.position.set(0, 0, 2);
    newLight.castShadow = false;
    scene.add(newLight);

    const newLightA = new THREE.DirectionalLight(0xffffff, 2);
    newLightA.position.set(0, 0, 20);
    newLightA.castShadow = false;
    //scene.add(newLightA);

    const helper = new THREE.DirectionalLightHelper(light);
    //scene.add(helper);

    const helpera = new THREE.DirectionalLightHelper(newLight);
    //scene.add(helpera);

    const helperb = new THREE.DirectionalLightHelper(newLightA);
    //scene.add(helperb);


    if (ground) {
        loadGround(service);
    }


    new RGBELoader()
        .setDataType(THREE.UnsignedByteType)
        .load("../../textures/Red.hdr", (texture) => {
            const envMap = pmremGenerator.fromEquirectangular(texture).texture;
            //scene.environment = envMap;
            renderer.render(scene, camera);
            //texture.dispose();
            //pmremGenerator.dispose();
            scene.background = envMap;
        });

    new RGBELoader()
        .setDataType(THREE.UnsignedByteType)
        .load("../../textures/studio_small_03_1k.hdr", (texture) => {
            const envMap = pmremGenerator.fromEquirectangular(texture).texture;
            scene.environment = envMap;
            renderer.render(scene, camera);
            texture.dispose();
            pmremGenerator.dispose();
            //scene.background = envMap;
        });


    controls.addEventListener("change", () =>
        renderOrSterio(service)
    ); // use if there is no animation loop


    controls.minDistance = 0.4;
    controls.maxDistance = 1;
    if (controlerRotatOnlyOnX) {
        controls.minPolarAngle = Math.PI / 2;
        controls.maxPolarAngle = Math.PI / 2;
    }
    controls.target.set(0, 0, 0);
    controls.autoRotate = controlerAutoRotat;
    controls.autoRotateSpeed = 20;
    controls.update();

    renderModel(service);




}

export function startLoad3d(service: RevolvaService) {
    let { loading3D } = service
    const { scene, camera, controls, productId, productsInfo, productsList, roughnessMipmapper, pieces, piecesInScene, dracoLoader } = service
    if (!loading3D) {
        loading3D = true;
        const element = document.getElementById("loading3dDev");
        if (element) {
            element.parentNode.removeChild(element);
        }

        // renderModel(service);
        const productFolder = productsList[productId].product;
        // use of RoughnessMipmapper is optional

        const manager = new THREE.LoadingManager();

        manager.onLoad = async () => {
            /* finishedLoading3D = true; */
        };
        const loader = new GLTFLoader(manager);
        loader.setDRACOLoader(dracoLoader);

        productsInfo.forEach((item) => {
            if (item.product == productFolder) {
                const path =
                    "../../productsList/" +
                    item.product +
                    "/" +
                    item.piece +
                    "/" +
                    item.spec +
                    "/" +
                    //service.stats = Stats();
                    item.file;

                loader.load(path, async (gltf) => {
                    const materialFunction = (child: THREE.Object3D): void => {
                        if (child instanceof THREE.Mesh) {
                            roughnessMipmapper.generateMipmaps(
                                (child as any).material // eslint-disable-line @typescript-eslint/no-explicit-any

                            );
                            // @ts-ignore
                            if (child.material.name === "gltf glass") {
                                // @ts-ignore
                                child.material.side = THREE.FrontSide;
                                // child.material.depthTest = false;
                            }
                            // @ts-ignore
                            if (child.material.name === "label") {
                                // @ts-ignore
                                child.material.side = THREE.DoubleSide;
                                // @ts-ignore
                                child.material.depthWrite = true;
                                // @ts-ignore
                                child.material.alphaTest = 0.5;
                            }
                            // @ts-ignore
                            child.material.envMapIntensity = 0.6;

                            /*  if (item.piece === 'piece2'){
                                 child.receiveShadow = true;
                                 child.castShadow = true; 
                             } */

                            if (child.name === 'Circle005') {

                                child.receiveShadow = true;
                            }
                            if (['Circle001', 'Circle002', 'Circle011'].includes(child.name)) {
                                child.castShadow = true;
                            }

                            if (child.name === 'Circle001' && item.piece == 'piece1') {
                                service.specialPieces[1] = child;
                            }
                            if (child.name === 'Circle002' && item.piece == 'piece1') {
                                service.specialPieces[2] = child;
                            }
                            if (child.name === 'Circle011' && item.piece == 'piece1') {
                                service.specialPieces[3] = child;
                            }








                        }



                    };



                    gltf.scene.traverse(materialFunction);
                    roughnessMipmapper.dispose();
                    pieces[item.id] = gltf.scene;
                    gltf.scene.name = item.name;


                    if (item.default == 1) {
                        scene.add(gltf.scene);
                        piecesInScene[item.piece] = gltf.scene;


                    }
                    if (item.lookAt == 1) {
                        camera.lookAt(gltf.scene.position);
                        const helper = new THREE.BoxHelper(gltf.scene);
                        helper.geometry.computeBoundingBox();
                        const center = helper.geometry.boundingBox.getCenter(new THREE.Vector3);
                        gltf.scene.localToWorld(center);

                        controls.target.set(center.x, center.y, center.z);
                        controls.update();
                        //renderModel(service);
                    }



                    if (item.piece == 'piece2') {
                        gltf.scene.add(service.sound);

                        //console.log(gltf.scene)
                        //adding animation
                        const animations = gltf.animations;

                        service.mixer = new THREE.AnimationMixer(gltf.scene);

                        for (let i = 0; i < animations.length; i++) {
                            const animation = animations[i];
                            // alert(animations.length);
                            //alert(item.id);
                            // There's .3333 seconds junk at the tail of the Monster animation that
                            // keeps it from looping cleanly. Clip it at 3 seconds
                            //if ( item.animationTime ) {

                            //							animation.duration = animations.length;

                            //							}

                            const action = service.mixer.clipAction(animation);

                            action.play();
                        }


                    }




                    actionsCustom.createAnnotationDom(service);

                    renderModel(service);
                });
            } //end of product
        }); //end of for each productsInfo
    } //end of if loading 3d

}

export function changePiecesInScene(service: RevolvaService, piece: string, id: number) {
    const { scene, pieces, piecesInScene } = service
    scene.remove(piecesInScene[piece]);
    piecesInScene[piece] = pieces[id];
    scene.add(piecesInScene[piece]);
    renderModel(service);
}


export function setProductId(service: RevolvaService, productId: number) {
    service.productId = productId;
}

export function setproductsListJson(service: RevolvaService, productsListJson: ProductList[]) {
    service.productsList = productsListJson;
}

export function setProductsInfo(service: RevolvaService, productsInfo: ProductInfo[]) {
    service.productsInfo = productsInfo;
}

export function setPiecesInfo(service: RevolvaService, piecesInfo: PiecesInfo[]) {
    service.piecesInfo = piecesInfo;
}

export function setCanvaHeight(service: RevolvaService, canvaHeight: number) {
    service.canvaHeight = canvaHeight;
}

export function setCanvaWeight(service: RevolvaService, canvasWidth: number) {
    service.canvasWidth = canvasWidth;
}

export function setCanvaSize(service: RevolvaService, canvasWidth: number, canvaHeight: number) {
    service.canvasWidth = canvasWidth;
    service.canvaHeight = canvaHeight;
}

export function setCameraAspect(service: RevolvaService) {
    service.camera.aspect = service.canvasWidth / service.canvaHeight;
}


export function setCanvas(service: RevolvaService, canvas: HTMLCanvasElement) {
    service.canvas = canvas;
}

export function setMainObjects(service: RevolvaService) {

    // Configure and create Draco decoder.
    service.dracoLoader = new DRACOLoader();
    service.dracoLoader.setDecoderPath('draco/');
    service.dracoLoader.setDecoderConfig({ type: 'js' });


    service.camera = new THREE.PerspectiveCamera(
        45,
        service.canvasWidth / service.canvaHeight,
        0.25,
        100
    );
    service.scene = new THREE.Scene();
    //service.scene.background = new THREE.Color(0x000000);
    //Load background texture
    // const loader = new THREE.TextureLoader();
    //loader.load('../../textures/AP_Red_HDRI.jpg', function (texture) {
    //   console.log('tt');
    //  service.scene.background = texture;
    //});
    service.renderer = new THREE.WebGLRenderer({ canvas: service.canvas, antialias: true, alpha: true });
    service.renderer.setSize(service.canvasWidth, service.canvaHeight);


    service.controls = new OrbitControls(service.camera, service.renderer.domElement);
    service.roughnessMipmapper = new RoughnessMipmapper(service.renderer);
    //service.light = new THREE.DirectionalLight(0xffa95c, 8);
    service.light = new THREE.DirectionalLight(0xffffff, 0.5);

    service.clock = new THREE.Clock();

    const listener = new THREE.AudioListener();
    service.camera.add(listener);
    const audioLoader = new THREE.AudioLoader();
    service.sound = new THREE.PositionalAudio(listener);
    audioLoader.load("sound/audemars.mp3", function (buffer) {
        service.sound.setBuffer(buffer);
        service.sound.setRefDistance(30);
        service.sound.loop = false;
        service.sound.onEnded = () => {
            //  console.log("end");
            service.playSound = false; /* sets Three wrapper property correctly */
        };
    });

    service.raycaster = new THREE.Raycaster();

    service.mouse = new THREE.Vector2();
    //console.log(service.renderer.domElement);
    service.renderer.domElement.addEventListener('click', e => {
        onPointerDown(service, e);
    });

    service.renderer.domElement.addEventListener('touchend', e => {
        onTouch(service, e);
    });





}

export function setCanvafullScreen(service: RevolvaService, status: boolean) {
    service.canvaFullScreen = status
}